import { RefObject } from "react";

const headerHeight = 134;

export const scrollToStart = (ref: RefObject<any>) => {
  const yOffset = -headerHeight;
  if (ref?.current) {
    const y = ref.current?.getBoundingClientRect().top + window.pageYOffset + yOffset;

    if (y) window.scrollTo({ top: y, behavior: 'smooth' });
  } else {
    const y = document.getElementById('bp-career-search-widget')?.getBoundingClientRect().top! + window.pageYOffset + yOffset;

    if (y) window.scrollTo({ top: y, behavior: 'smooth' });
  }
};